import { defineMessage } from 'services/localization';

export const messages = {
    profileInfoName: defineMessage('my_profile'),
    profileInfoTitle: defineMessage('edit_your_profile_details_and_change_your_password'),
    profileDelegatesName: defineMessage('out_of_office'),
    profileDelegatesTitle: defineMessage('temporary_approval_authority_as_a_substitute'),
    darkTheme: defineMessage('dark_theme'),
};
